import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useAppContext } from '../../../../contexts/AppContext';
import { urlEmpresas, urlContratos } from '../../../../constants/endpoints';

const getContratoPorId = (id) => axios.get(`${urlContratos}/${id}`);

function useContratoEmpresa(select) {
    const { dadosUsuario } = useAppContext();
    const empresaId = dadosUsuario?.pessoa?.empresa?.id;
    return useQuery({
        queryKey: ['contrato', empresaId],
        queryFn: async () => {
            const respEmpresa = await axios.get(`${urlEmpresas}/${empresaId}`, {
                params: { total_usuarios: true },
            });
            const empresa = respEmpresa.data.data;

            const idContrato = empresa?.idContrato;
            if (!idContrato) throw new Error('Empresa sem contrato');
            const respContrato = await getContratoPorId(idContrato);

            return {
                contrato: respContrato.data.data,
                totalUsuarios: empresa?.total_usuarios,
            };
        },
        select,
    });
}

export const useContrato = () =>
    useContratoEmpresa((data) => data.contrato);

export const useTotalUsuarios = () =>
    useContratoEmpresa((data) => ({
        colaboradores: data.totalUsuarios?.colaboradores ?? 0,
        administradores: data.totalUsuarios?.administradores ?? 0,
        total: data.totalUsuarios?.total ?? 0,
    }));